module.exports = __webpack_public_path__ + "img/oferta.f6ff5d9c.png";